import { FC, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@robocorp/components';

import CodeEditor from '../../CodeEditor';
import type { JSONEditorProps } from '../types';

export const RawEditor: FC<JSONEditorProps> = ({
  value,
  onChange,
  error,
  setError,
  lineWrapping,
  height = 160,
}) => {
  const { t } = useTranslation();
  const [localValue, setLocalValue] = useState('');

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  useEffect(() => {
    try {
      JSON.parse(localValue);
      setError?.(false);
    } catch (_err) {
      setError?.(true);
    }
  }, [setError, localValue]);

  const onBlur = useCallback(() => {
    try {
      JSON.parse(localValue);
      onChange(localValue);
      setError?.(false);
    } catch (_err) {
      setError?.(true);
    }
  }, [localValue, onChange, setError]);

  return (
    <>
      <Box height={height}>
        <CodeEditor
          mode="json"
          value={localValue}
          onChange={setLocalValue}
          onBlur={onBlur}
          theme="dark"
          multiLine
          copyToClipboard
          autoFocus
          lineWrapping={lineWrapping}
        />
      </Box>
      {error && (
        <Typography mt="$8" variant="body.small" color="content.error">
          {t('jsonEditor.invalidJSONError')}
        </Typography>
      )}
    </>
  );
};
